import { FC } from 'react';
import { Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { TermsThemeContainer } from '@bizapp-lp/pjr/molecules/TermsTheme';
import {
  Terms as TermsOrganisms,
  TermsProps as TermsPropsOrganisms,
} from '@bizapp-lp/pjr/organisms/Terms';
import { Footer } from '@bizapp-lp/pjr/organisms/Footer';
import { Header } from '@bizapp-lp/pjr/organisms/Header';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#f2f3fb 0% 0% no-repeat padding-box',
      padding: theme.spacing(5, 2, 10),
      [theme.breakpoints.up('sm')]: { padding: theme.spacing(5, 5, 10) },
    },
    title: {
      marginBottom: theme.spacing(5),
    },
  }),
);

export interface TermsProps extends TermsPropsOrganisms {
  className?: string;
  pageTitle: string | JSX.Element | JSX.Element[];
}

export const Terms: FC<TermsProps> = ({
  className,
  pageTitle,
  headerContent,
  children,
}) => {
  const classes = useStyles();

  return (
    <>
      <Header />
      <Container
        disableGutters
        maxWidth={false}
        className={`${classes.root} ${className ?? ''}`}
      >
        <TermsThemeContainer className={classes.title}>
          <Typography variant="h1">{pageTitle}</Typography>
        </TermsThemeContainer>
        <TermsThemeContainer>
          <TermsOrganisms headerContent={headerContent}>
            {children}
          </TermsOrganisms>
        </TermsThemeContainer>
      </Container>
      <Footer />
    </>
  );
};
